export default class GooglePlayReportQuery {

    public static GetGooglePlayReport = `query GooglePlayReportQuery($input: ReportInput!) {
            getGooglePlayReport(input: $input) {
                date
                packageName
                dailyDeviceInstalls
                dailyDeviceUninstalls
                dailyDeviceUpgrades
                totalUserInstalls
                dailyUserInstalls
                dailyUserUninstalls
                activeDeviceInstalls
                installEvents
                updateEvents
                uninstallEvents
            }     
        }`;
}